<template>
  <div>
    <template v-if="loaded">
      <div class="row justify-content-center my-5">
        <div class="col-md-8">
          <form @submit.prevent="submit">
            <base-card>
              <p>
                Please provide information for all of the company shareholders.
              </p>
              <shareholder-entry
                v-for="key in Object.keys(payloads)"
                v-model="payloads[key]"
                :key="key"
                @remove="remove(key)"/>
              <div class="row">
                <div :class="completed" class="col-sm-6">
                  <strong>Total Completed:</strong> {{ total }}%
                </div>
                <div class="col-sm-6 text-sm-right">
                  <base-button class="mt-2" icon-right="plus" @click="add()">
                    Add Another Shareholder
                  </base-button>
                </div>
              </div>
              <template v-slot:footer>
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <base-button icon-left="arrow-left" :to="{ name: 'register.directors' }">
                      Back to Directors
                    </base-button>
                  </div>
                  <div class="col-12 col-sm-6 text-right">
                    <base-button icon-right="arrow-right" :loading="saving" primary submit>
                      <template v-if="$auth.investor()">
                        Continue to Investor
                      </template>
                      <template v-else>
                        Continue to your Interests
                      </template>
                    </base-button>
                  </div>
                </div>
              </template>
            </base-card>
          </form>
        </div>
      </div>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ShareholderEntry from '@/components/ShareholderEntry.vue'

export default {
  async mounted () {
    await this.$store.dispatch('core/directors/list', {
      query: {
        user: this.user._id
      }
    })
    await this.$store.dispatch('core/shareholders/list', {
      query: {
        user: this.user._id
      }
    })

    this.payloads = this.$_.cloneDeep(this.shareholders)

    if (this.payloads.length === 0) {
      this.add()
    }

    this.loaded = true
  },

  data: () => ({
    deleting: [],
    loaded: false,
    payloads: [],
    saving: false
  }),

  components: {
    ShareholderEntry
  },

  computed: {
    completed () {
      const total = parseFloat(this.total)

      return {
        'text-danger': total !== 100.00,
        'text-success': total === 100.00
      }
    },

    total () {
      let total = this.$big(0)

      this.payloads.forEach(({ percentageShare }) => {
        if (percentageShare !== '' && !isNaN(percentageShare)) {
          total = total.plus(percentageShare)
        }
      })

      return total.toFixed(2)
    },

    ...mapGetters({
      schema: 'core/user-profile/schema'
    }),

    ...mapState({
      directors: store => store.core.directors.rows,
      profile: store => store.core.userProfile.entity,
      shareholder: store => store.core.shareholders.entity,
      shareholders: store => store.core.shareholders.rows,
      user: store => store.core.auth.user
    })
  },

  methods: {
    add () {
      this.payloads.push({
        email: '',
        percentageShare: '0',
        director: null,
        profile: this.$_.cloneDeep(this.schema),
        user: this.user._id
      })
    },

    remove (index) {
      const { _id } = this.payloads[index]

      if (_id) this.deleting.push(_id)

      this.payloads.splice(index, 1)
    },

    async submit () {
      this.saving = true

      const payloads = this.$_.cloneDeep(this.payloads)

      await Promise.all(
        payloads.map(async shareholder => {
          // Create the profile for the shareholder if they're not a director.
          if (!shareholder.director) {
            await this.$store.dispatch('core/user-profile/save', shareholder.profile)

            shareholder.profile = this.profile._id
          } else {
            shareholder.director = shareholder.director._id
          }

          // Save the shareholder with their profile.
          await this.$store.dispatch('core/shareholders/save', shareholder)
        })
      )

      // Do we have shareholders to delete?
      if (this.deleting) {
        await Promise.all(
          this.deleting.map(async _id => {
            await this.$store.dispatch('core/shareholders/remove', _id)
          })
        )
      }

      const profile = this.$_.cloneDeep(this.user.profile)
      profile.verifications.registrationCompleted = true
      await this.$store.dispatch('core/auth/update-profile', profile)

      this.saving = false

      this.$router.push({
        name: this.$auth.investor() ? 'register.statutory' : 'dashboard'
      })
    }
  }
}
</script>
